import {AnimationLoadingBaseController, IAnimationControllerConfiguration, ILoadingBaseController} from "@denishussar/html5-game-engine";
import {Inject} from "@denishussar/html5-game-engine";
import {AnimationContents} from "../AnimationContents";

export interface ILoaderGameControllerOptions {
    test: string;
}

export class LoaderGameController extends AnimationLoadingBaseController implements ILoadingBaseController
{
    public $model;

    public constructor(@Inject private _options: ILoaderGameControllerOptions)
    {
        super("LoaderGameController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.PRELOADER_SCREEN_JSON,
            libraryName: "loader_screen"
        };
    }

    protected onInitialize(): void {
        this.gotoAndPlayByQuery("loader", 0, true);
        this.scaleX = 0.5;
        this.scaleY = 0.5;
    }

    protected onUpdate(frameRate: number): void {
    }

    public onLoadingProgress(progress: number): void {

    }

    public onHide(): void {
        this.gotoAndStopByQuery("loader", 0);
    }

    public onShow(): void {
        this.gotoAndPlayByQuery("loader", 0, true);
    }
}
